import type { RouteLocationRaw } from 'vue-router'
import type { TodoCalendar } from '@/api'

// Opening the Todos tab (or the website, or the Mini App) shows the lists page, unless there is only one list: then it is
// the list itself, since a page with one entry is a detour. Nothing here is a redirect for the lists page as such, it can
// still be browsed by hand through `calendarsBrowseLocation` (the back arrow of a list).
export function todosEntryRedirect(calendars: TodoCalendar[]): RouteLocationRaw | null {
  return calendars.length === 1
    ? { name: 'todo-list', params: { calendarId: calendars[0].id } }
    : null
}

export const calendarsBrowseLocation: RouteLocationRaw = { name: 'todos', query: { browse: '1' } }
